import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';


@Injectable({providedIn: 'root'})
export class IdempotencyService {

  private keys: Map<string, string> = new Map();

  generateKey(operation: string): string {
    if (!this.keys.has(operation)) {
      const key = uuidv4();
      this.keys.set(operation, key);
    }

    return this.keys.get(operation)!;
  }

  clearKey(operation: string): void {
    this.keys.delete(operation);
  }

  createHeaders(operation: string): HttpHeaders {
    const key = this.generateKey(operation);
    return new HttpHeaders({
      'Idempotency-Key': key
    });
  }

  finalizeClear(operation: string): () => void {
    return () => this.clearKey(operation);
  }

}
